<template>
  <div>
    <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />
    <b-card>
      <div style="position: relative">
        <loading-overlay :loading="loading" />

        <b-tabs v-model="activeTab">
          <template #tabs-end>
            <li class="ml-auto d-flex justify-content-end">
              <div v-can="{ slug: $route.meta.slug, action: 'C' }">
                <b-button @click="incentivesModal = true" variant="success">
                  إضافة
                </b-button>
              </div>
            </li>
          </template>
          <b-tab title="الثناءات">
            <b-list-group>
              <b-list-group-item
                v-for="reward in incentives.filter((e) => e.type === 'reward')"
                :key="reward.id"
                class="flex-column align-items-start"
              >
                <div class="d-flex w-100 justify-content-between">
                  <div>
                    <h5>{{ reward.name }}</h5>
                    <div class="text-secondary mb-1">
                      {{ reward.ngo.name_ar }}
                    </div>
                    <small v-if="reward.read_at" class="text-secondary">
                      شوهد بتاريخ :
                      <time>
                        {{
                          $moment(reward.read_at)
                            .locale("ar-iq")
                            .format("h:mm a , DD-MM-YYYY ")
                        }}
                      </time>
                    </small>
                  </div>

                  <div>
                    <small dir="ltr" class="text-secondary">{{
                      $moment(reward.created_at)
                        .locale("ar-iq")
                        .format("h:mm a , DD-MM-YYYY ")
                    }}</small>
                    <div class="d-flex justify-content-end">
                      <router-link
                        :to="{
                          name: 'file-view',
                          query: { ep: reward.source },
                        }"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <b-button
                          variant="flat-success"
                          class="btn-icon rounded-circle"
                        >
                          <feather-icon icon="EyeIcon" />
                        </b-button>
                      </router-link>
                      <b-button
                        v-can="{ slug: $route.meta.slug, action: 'U' }"
                        variant="flat-primary"
                        class="btn-icon rounded-circle"
                        @click="onEditClicked(reward)"
                      >
                        <feather-icon icon="EditIcon" />
                      </b-button>
                      <b-button
                        v-can="{ slug: $route.meta.slug, action: 'D' }"
                        @click="onDeleteClicked(reward.id)"
                        variant="flat-danger"
                        class="btn-icon rounded-circle"
                      >
                        <feather-icon icon="Trash2Icon" />
                      </b-button>
                    </div>
                  </div>
                </div>
              </b-list-group-item>

              <div v-if="incentives.length === 0" class="p-1 text-center">
                لا توجد أي ثناءات
              </div>
            </b-list-group>
          </b-tab>
          <b-tab title="العقوبات">
            <b-list-group>
              <b-list-group-item
                v-for="punishment in incentives.filter(
                  (e) => e.type === 'punishment'
                )"
                :key="punishment.id"
                class="flex-column align-items-start"
              >
                <b-row class="d-flex w-100 justify-content-between">
                  <b-col cols="3">
                    <h5>{{ punishment.name }}</h5>
                    <div class="text-secondary mb-1">
                      {{ punishment.ngo.name_ar }}
                    </div>

                    <small v-if="punishment.read_at" class="text-secondary">
                      شوهد بتاريخ :
                      <time>
                        {{
                          $moment(punishment.read_at)
                            .locale("ar-iq")
                            .format("h:mm a , DD-MM-YYYY ")
                        }}
                      </time>
                    </small>
                  </b-col>
                  <b-col cols="3" class="d-flex justify-content-center align-items-center">
                    <div v-if="punishment.status">
                      <b-badge
                        pill
                        :variant="punishment.status=== 'confirmed' ? 'light-danger' : punishment.status=== 'under_study' ? 'light-secondary' : 'light-success'"
                      >
                        {{ punishment.status=== 'confirmed' ? 'محققة' : punishment.status=== 'under_study' ? 'تحت الدراسة' : 'مًلغاة' }}
                      </b-badge>
                    </div>
                  </b-col>
                  <b-col cols="3" class="d-flex justify-content-center align-items-center">
                    <div v-if="punishment.transaction_request_id"> 
                      وفق المعاملة 
                      <b-badge
                          pill
                          variant="light-secondary"
                        >
                          {{ punishment.transaction_request_id }} 
                        </b-badge>
                    </div>
                  </b-col>
                  <b-col cols="3"  class="d-flex justify-content-end align-items-center">
                    <small class="text-secondary">{{
                      $moment(punishment.created_at)
                        .locale("ar-iq")
                        .format("h:mm a , DD-MM-YYYY ")
                    }}</small>

                    <div class="d-flex justify-content-end">
                      <router-link
                        :to="{
                          name: 'file-view',
                          query: { ep: punishment.source },
                        }"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <b-button
                          variant="flat-success"
                          class="btn-icon rounded-circle"
                        >
                          <feather-icon icon="EyeIcon" />
                        </b-button>
                      </router-link>
                      <b-button
                        v-can="{ slug: $route.meta.slug, action: 'U' }"
                        variant="flat-primary"
                        class="btn-icon rounded-circle"
                        @click="onEditClicked(punishment)"
                      >
                        <feather-icon icon="EditIcon" />
                      </b-button>
                      <b-button
                        v-can="{ slug: $route.meta.slug, action: 'D' }"
                        @click="onDeleteClicked(punishment.id)"
                        variant="flat-danger"
                        class="btn-icon rounded-circle"
                      >
                        <feather-icon icon="Trash2Icon" />
                      </b-button>
                    </div>
                  </b-col>
                </b-row>
              </b-list-group-item>

              <div v-if="incentives.length === 0" class="p-1 text-center">
                لا توجد أي ثناءات
              </div>
            </b-list-group>
          </b-tab>
        </b-tabs>
      </div>
    </b-card>
    <form-modal
      static
      ref="incentivesModal"
      title="أدخل معلومات المستند"
      :loading="working"
      :formSchema="incentivesFormSchema"
      v-model="incentivesModal"
      @confirm="onConfirm"
    />
  </div>
</template>
<script>
import {
  BRow,
  BCard,
  BLink,
  BTabs,
  BTab,
  BButton,
  BCol,
  BContainer,
  BListGroup,
  BListGroupItem,
  BFormFile,
  BBadge,
} from "bootstrap-vue";
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import { mapGetters, mapActions } from "vuex";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import FormModal from "@/components/FormModal.vue";

export default {
  components: {
    BRow,
    BCard,
    BLink,
    BButton,
    BCol,
    BContainer,
    BListGroup,
    BListGroupItem,
    BFormFile,
    BTabs,
    BTab,
    LoadingOverlay,
    MinistryBreadcrumbs,
    ToastificationContent,
    FormModal,
    BBadge,
  },
  data() {
    return {
      activeTab: 0,
      incentivesModal: false,
      mainTitle: "الثناءات و العقوبات",
      breadcrumbs: [
        {
          text: "إدارة المنظمات",
          to: "/ministry/ngos-communication",
        },
        {
          text: "الثناءات و العقوبات",
          active: true,
        },
      ],
      incentivesFormSchema: {
        name: {
          component: "FormInput",
          key: "name",
          attrs: {
            label: "الاسم",
            rules: "required",
          },
        },

        ngo_id: {
          component: "FormAutocomplete",
          key: "ngo_id",
          attrs: {
            id: "ngo-id",
            label: "المنظمة",
            ep: "v2/ministry/selects/ngos",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name_ar,
            rules: "required",
          },
        },
        decision_no: {
          component: "FormCleave",
          key: "decision_no",
          attrs: {
            label: "رقم القرار",
            rules: "required",
            isNumber: true,
          },
        },
        decision_date: {
          component: "FormMask",
          key: "decision_date",
          attrs: {
            options: "date",
            placeholder: "YYYY-MM-DD",
            label: "تاريخ القرار",
            rules: "required",
          },
        },
        type: {
          component: "FormSelect",
          key: "type",
          attrs: {
            id: "type-select",
            label: "التصنيف",
            rules: "required",
            getOptionLabel: (x) => x.text,
            reduce: (x) => x.value,
            options: [
              {
                text: "ثناء",
                value: "reward",
              },
              {
                text: "عقوبة",
                value: "punishment",
              },
            ],
          },
        },

        incentive_type_id: {
          component: "FormSelect",
          key: "incentive_type_id",
          attrs: {
            id: "incentive-type",
            label: "النوع",
            ep: "v2/ministry/selects/incentive-types",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name_ar,
            rules: "required",
          },
        },
        source: {
          key: "source",
          component: "FormFileInput",
          attrs: {
            label: "الملف",
            accept: "application/pdf",
          },
        },
      },
    };
  },
  methods: {
    ...mapActions("Ministry/Communication/Incentives", [
      "getIncentives",
      "editIncentive",
      "addIncentive",
      "deleteIncentive",
    ]),
    async onConfirm(form) {
      var toSend = new FormData();
      for (const key in form) {
        if (Object.hasOwnProperty.call(form, key)) {
          const element = form[key];
          toSend.append(key, element);
        }
      }
      if (form.id) {
        await this.editIncentive({ form: toSend, id: form.id });
      } else {
        await this.addIncentive(toSend);
      }
      this.incentivesModal = false;
      this.getIncentives();
    },
    onEditClicked(item) {
      var x = { ...item };
      delete x.ngo;
      x.ngo_id = item.ngo.id;
      delete x.incentiveType;
      x.incentive_type_id = item.incentiveType.id;
      this.$store.commit("ngo-id/setOptions", [{ ...item.ngo }]);
      this.$refs.incentivesModal.init({ ...x });
      this.incentivesModal = true;
    },

    onDeleteClicked(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف المستند ؟", {
          title: "تأكيد حذف المستند",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            await this.deleteIncentive(id).then(() => {
              this.getIncentives();
            });
          }
        });
    },
  },
  computed: {
    ...mapGetters("Ministry/Communication/Incentives", [
      "incentives",
      "loading",
      "working",
    ]),
  },

  created() {
    this.getIncentives();
  },
};
</script>

<style lang="scss" scoped></style>
